// extracted by mini-css-extract-plugin
module.exports = {"nearbyBuoys":"NearbyBuoys_nearbyBuoys__fOGgm"};